import { languages, type TLanguageCode } from 'countries-list';

export function getLanguageName(languageCode: string): string {
  try {
    return languages[languageCode as TLanguageCode].name;
  } catch {
    console.error('Invalid language code:', languageCode);
    return languageCode;
  }
}
